exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-state{min-width:1rem;max-width:100%;display:inline-flex;border-radius:.25rem;background-color:var(--fts-default);cursor:default}.fts-state>div{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-left:.375rem;padding-right:.375rem;font-weight:var(--inistate-font-weight-medium);font-size:var(--inistate-label-text-14);line-height:var(--inistate-paragraph-text-14--line-height);color:var(--fts-light);cursor:inherit}.fts-state.fts-state-md>div{font-size:1rem;line-height:1.5}", ""]);

// exports
